// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/singular_day_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { AreaCode } from "../../bfftypes/v1/area_pb";
import { file_bfftypes_v1_area } from "../../bfftypes/v1/area_pb";
import type { SingularDay, SingularDayCategory, SingularDayDemandBehavior, SingularGroupName } from "./singular_day_model_pb";
import { file_bffuser_v1_singular_day_model } from "./singular_day_model_pb";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Date } from "../../google/type/date_pb";
import { file_google_type_date } from "../../google/type/date_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/singular_day_service.proto.
 */
export const file_bffuser_v1_singular_day_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_bfftypes_v1_area, file_bffuser_v1_singular_day_model, file_buf_validate_validate, file_google_protobuf_timestamp, file_google_type_date]);

/**
 * ListSingularDaysRequest carries only fiscal_year.
 *
 * @generated from message bffuser.v1.ListSingularDaysRequest
 */
export type ListSingularDaysRequest = Message<"bffuser.v1.ListSingularDaysRequest"> & {
  /**
   * 対象年度 (4/1〜翌3/31 の範囲に展開する年)。未指定時は全年度の特異日を返す。
   *
   * @generated from field: optional int32 fiscal_year = 1;
   */
  fiscalYear?: number;
};

/**
 * Describes the message bffuser.v1.ListSingularDaysRequest.
 * Use `create(ListSingularDaysRequestSchema)` to create a new message.
 */
export const ListSingularDaysRequestSchema: GenMessage<ListSingularDaysRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_singular_day_service, 0);

/**
 * @generated from message bffuser.v1.ListSingularDaysResponse
 */
export type ListSingularDaysResponse = Message<"bffuser.v1.ListSingularDaysResponse"> & {
  /**
   * @generated from field: repeated bffuser.v1.SingularDay singular_days = 1;
   */
  singularDays: SingularDay[];
};

/**
 * Describes the message bffuser.v1.ListSingularDaysResponse.
 * Use `create(ListSingularDaysResponseSchema)` to create a new message.
 */
export const ListSingularDaysResponseSchema: GenMessage<ListSingularDaysResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_singular_day_service, 1);

/**
 * organization_id and created_by are resolved by the BFF handler from
 * eauth; they are intentionally absent from the frontend-facing request.
 *
 * @generated from message bffuser.v1.CreateSingularDayRequest
 */
export type CreateSingularDayRequest = Message<"bffuser.v1.CreateSingularDayRequest"> & {
  /**
   * @generated from field: google.type.Date date = 1;
   */
  date?: Date;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: bffuser.v1.SingularDayCategory category = 4;
   */
  category: SingularDayCategory;

  /**
   * @generated from field: bffuser.v1.SingularDayDemandBehavior demand_behavior = 5;
   */
  demandBehavior: SingularDayDemandBehavior;

  /**
   * Target areas. Empty = all-area-common; the backend normalizes the
   * all-ten selection and rejects duplicates.
   *
   * @generated from field: repeated bfftypes.v1.AreaCode area_codes = 6;
   */
  areaCodes: AreaCode[];

  /**
   * 特異グループ番号 (1〜10)。frontend は常に選択済みの値 (1〜10) を送る。
   * 未指定 (wire 0) は不正として reject する (fail-closed、design Note
   * singular-day-special-group.md D2 改訂 / PR review C1)。
   *
   * @generated from field: int32 singular_group = 7;
   */
  singularGroup: number;
};

/**
 * Describes the message bffuser.v1.CreateSingularDayRequest.
 * Use `create(CreateSingularDayRequestSchema)` to create a new message.
 */
export const CreateSingularDayRequestSchema: GenMessage<CreateSingularDayRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_singular_day_service, 2);

/**
 * @generated from message bffuser.v1.CreateSingularDayResponse
 */
export type CreateSingularDayResponse = Message<"bffuser.v1.CreateSingularDayResponse"> & {
  /**
   * @generated from field: bffuser.v1.SingularDay singular_day = 1;
   */
  singularDay?: SingularDay;

  /**
   * 保存した特異日の日付に、既存の「全エリア共通」特異日が存在する場合は
   * その名称を返す (AC-MSD-013a)。空文字 / 未設定時はバナー非表示。
   *
   * @generated from field: optional string overridden_all_area_name = 2;
   */
  overriddenAllAreaName?: string;
};

/**
 * Describes the message bffuser.v1.CreateSingularDayResponse.
 * Use `create(CreateSingularDayResponseSchema)` to create a new message.
 */
export const CreateSingularDayResponseSchema: GenMessage<CreateSingularDayResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_singular_day_service, 3);

/**
 * id is the surrogate identity lookup. organization_id and updated_by are
 * resolved by the BFF handler from eauth.
 *
 * @generated from message bffuser.v1.UpdateSingularDayRequest
 */
export type UpdateSingularDayRequest = Message<"bffuser.v1.UpdateSingularDayRequest"> & {
  /**
   * Deprecated: date is stable and not updatable; the row is identified by
   * id. Kept for wire compatibility; the handler ignores it.
   *
   * @generated from field: google.type.Date date = 1 [deprecated = true];
   * @deprecated
   */
  date?: Date;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * Optimistic-lock baseline. Must match the current updated_at of the
   * record; the server returns ABORTED when they differ.
   *
   * @generated from field: google.protobuf.Timestamp expected_updated_at = 4;
   */
  expectedUpdatedAt?: Timestamp;

  /**
   * @generated from field: bffuser.v1.SingularDayCategory category = 5;
   */
  category: SingularDayCategory;

  /**
   * @generated from field: bffuser.v1.SingularDayDemandBehavior demand_behavior = 6;
   */
  demandBehavior: SingularDayDemandBehavior;

  /**
   * Surrogate identity of the row to update.
   *
   * @generated from field: string id = 7;
   */
  id: string;

  /**
   * Target areas. Empty = all-area-common; the backend normalizes the
   * all-ten selection and rejects duplicates.
   *
   * @generated from field: repeated bfftypes.v1.AreaCode area_codes = 8;
   */
  areaCodes: AreaCode[];

  /**
   * 特異グループ番号 (1〜10)。未指定 (wire 0) は reject する
   * (CreateSingularDayRequest.singular_group 参照。fail-closed)。
   *
   * @generated from field: int32 singular_group = 9;
   */
  singularGroup: number;
};

/**
 * Describes the message bffuser.v1.UpdateSingularDayRequest.
 * Use `create(UpdateSingularDayRequestSchema)` to create a new message.
 */
export const UpdateSingularDayRequestSchema: GenMessage<UpdateSingularDayRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_singular_day_service, 4);

/**
 * @generated from message bffuser.v1.UpdateSingularDayResponse
 */
export type UpdateSingularDayResponse = Message<"bffuser.v1.UpdateSingularDayResponse"> & {
  /**
   * @generated from field: bffuser.v1.SingularDay singular_day = 1;
   */
  singularDay?: SingularDay;

  /**
   * 保存した特異日の日付に、既存の「全エリア共通」特異日が存在する場合は
   * その名称を返す (AC-MSD-013a)。空文字 / 未設定時はバナー非表示。
   *
   * @generated from field: optional string overridden_all_area_name = 2;
   */
  overriddenAllAreaName?: string;
};

/**
 * Describes the message bffuser.v1.UpdateSingularDayResponse.
 * Use `create(UpdateSingularDayResponseSchema)` to create a new message.
 */
export const UpdateSingularDayResponseSchema: GenMessage<UpdateSingularDayResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_singular_day_service, 5);

/**
 * id is the surrogate identity lookup. organization_id is resolved by the
 * BFF handler from eauth.
 *
 * @generated from message bffuser.v1.DeleteSingularDayRequest
 */
export type DeleteSingularDayRequest = Message<"bffuser.v1.DeleteSingularDayRequest"> & {
  /**
   * Deprecated: the row is identified by id; the handler ignores date.
   *
   * @generated from field: google.type.Date date = 1 [deprecated = true];
   * @deprecated
   */
  date?: Date;

  /**
   * Optimistic-lock baseline. Must match the current updated_at of the
   * record; the server returns ABORTED when they differ.
   *
   * @generated from field: google.protobuf.Timestamp expected_updated_at = 2;
   */
  expectedUpdatedAt?: Timestamp;

  /**
   * Surrogate identity of the row to delete.
   *
   * @generated from field: string id = 3;
   */
  id: string;
};

/**
 * Describes the message bffuser.v1.DeleteSingularDayRequest.
 * Use `create(DeleteSingularDayRequestSchema)` to create a new message.
 */
export const DeleteSingularDayRequestSchema: GenMessage<DeleteSingularDayRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_singular_day_service, 6);

/**
 * DeleteSingularDayResponse is intentionally empty (AIP-135).
 *
 * @generated from message bffuser.v1.DeleteSingularDayResponse
 */
export type DeleteSingularDayResponse = Message<"bffuser.v1.DeleteSingularDayResponse"> & {
};

/**
 * Describes the message bffuser.v1.DeleteSingularDayResponse.
 * Use `create(DeleteSingularDayResponseSchema)` to create a new message.
 */
export const DeleteSingularDayResponseSchema: GenMessage<DeleteSingularDayResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_singular_day_service, 7);

/**
 * @generated from message bffuser.v1.ListSingularGroupNamesRequest
 */
export type ListSingularGroupNamesRequest = Message<"bffuser.v1.ListSingularGroupNamesRequest"> & {
};

/**
 * Describes the message bffuser.v1.ListSingularGroupNamesRequest.
 * Use `create(ListSingularGroupNamesRequestSchema)` to create a new message.
 */
export const ListSingularGroupNamesRequestSchema: GenMessage<ListSingularGroupNamesRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_singular_day_service, 8);

/**
 * @generated from message bffuser.v1.ListSingularGroupNamesResponse
 */
export type ListSingularGroupNamesResponse = Message<"bffuser.v1.ListSingularGroupNamesResponse"> & {
  /**
   * 命名済みの行のみ (未命名グループは欠落 → client が既定名を補完).
   *
   * @generated from field: repeated bffuser.v1.SingularGroupName singular_group_names = 1;
   */
  singularGroupNames: SingularGroupName[];
};

/**
 * Describes the message bffuser.v1.ListSingularGroupNamesResponse.
 * Use `create(ListSingularGroupNamesResponseSchema)` to create a new message.
 */
export const ListSingularGroupNamesResponseSchema: GenMessage<ListSingularGroupNamesResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_singular_day_service, 9);

/**
 * organization_id and updated_by are resolved by the BFF handler from
 * eauth; they are intentionally absent from the frontend-facing request.
 *
 * @generated from message bffuser.v1.SaveSingularGroupNamesRequest
 */
export type SaveSingularGroupNamesRequest = Message<"bffuser.v1.SaveSingularGroupNamesRequest"> & {
  /**
   * per-group upsert batch: entry.name 非空 → upsert, 空 → DELETE. 同一
   * singular_group の重複 entry はハンドラで reject する。
   *
   * @generated from field: repeated bffuser.v1.SingularGroupName entries = 1;
   */
  entries: SingularGroupName[];
};

/**
 * Describes the message bffuser.v1.SaveSingularGroupNamesRequest.
 * Use `create(SaveSingularGroupNamesRequestSchema)` to create a new message.
 */
export const SaveSingularGroupNamesRequestSchema: GenMessage<SaveSingularGroupNamesRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_singular_day_service, 10);

/**
 * SaveSingularGroupNamesResponse is intentionally empty (AIP-135, no
 * optimistic lock to echo back).
 *
 * @generated from message bffuser.v1.SaveSingularGroupNamesResponse
 */
export type SaveSingularGroupNamesResponse = Message<"bffuser.v1.SaveSingularGroupNamesResponse"> & {
};

/**
 * Describes the message bffuser.v1.SaveSingularGroupNamesResponse.
 * Use `create(SaveSingularGroupNamesResponseSchema)` to create a new message.
 */
export const SaveSingularGroupNamesResponseSchema: GenMessage<SaveSingularGroupNamesResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_singular_day_service, 11);

/**
 * SingularDayService manages the 特異日カレンダーマスタ consumed by the
 * frontend admin pages.
 *
 * @generated from service bffuser.v1.SingularDayService
 */
export const SingularDayService: GenService<{
  /**
   * ListSingularDays returns every active SingularDay for the current
   * organization within the given fiscal year. organization_id is
   * resolved by the BFF handler from eauth.
   *
   * @generated from rpc bffuser.v1.SingularDayService.ListSingularDays
   */
  listSingularDays: {
    methodKind: "unary";
    input: typeof ListSingularDaysRequestSchema;
    output: typeof ListSingularDaysResponseSchema;
  },
  /**
   * CreateSingularDay registers a new SingularDay (or revives a tombstone
   * date, AC-11). organization_id and created_by are resolved by the BFF
   * handler from eauth.
   *
   * @generated from rpc bffuser.v1.SingularDayService.CreateSingularDay
   */
  createSingularDay: {
    methodKind: "unary";
    input: typeof CreateSingularDayRequestSchema;
    output: typeof CreateSingularDayResponseSchema;
  },
  /**
   * UpdateSingularDay updates the name / category / demand_behavior of an
   * existing SingularDay. date is immutable after creation. Uses optimistic
   * locking via expected_updated_at. organization_id and updated_by are
   * resolved by the BFF handler from eauth.
   *
   * @generated from rpc bffuser.v1.SingularDayService.UpdateSingularDay
   */
  updateSingularDay: {
    methodKind: "unary";
    input: typeof UpdateSingularDayRequestSchema;
    output: typeof UpdateSingularDayResponseSchema;
  },
  /**
   * DeleteSingularDay logically deletes a SingularDay. Uses optimistic
   * locking via expected_updated_at. organization_id is resolved by the
   * BFF handler from eauth.
   *
   * @generated from rpc bffuser.v1.SingularDayService.DeleteSingularDay
   */
  deleteSingularDay: {
    methodKind: "unary";
    input: typeof DeleteSingularDayRequestSchema;
    output: typeof DeleteSingularDayResponseSchema;
  },
  /**
   * ListSingularGroupNames returns every 命名済み 特異グループ display name
   * for the current organization. organization_id is resolved by the BFF
   * handler from eauth.
   *
   * @generated from rpc bffuser.v1.SingularDayService.ListSingularGroupNames
   */
  listSingularGroupNames: {
    methodKind: "unary";
    input: typeof ListSingularGroupNamesRequestSchema;
    output: typeof ListSingularGroupNamesResponseSchema;
  },
  /**
   * SaveSingularGroupNames applies a per-group upsert batch: a non-empty
   * entry name upserts that group's display name, an empty name deletes it
   * (= 既定名に戻す). organization_id and updated_by are resolved by the BFF
   * handler from eauth.
   *
   * @generated from rpc bffuser.v1.SingularDayService.SaveSingularGroupNames
   */
  saveSingularGroupNames: {
    methodKind: "unary";
    input: typeof SaveSingularGroupNamesRequestSchema;
    output: typeof SaveSingularGroupNamesResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_bffuser_v1_singular_day_service, 0);

